import { Checkbox, CheckboxProps, styled, Box } from "@mui/material";
import { tokens } from "../../theme/tokens";

const CustomCheckboxIcon = styled(Box)<{ disabled?: boolean }>(({ disabled }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '4px',
  border: `2px solid ${disabled ? tokens.colors.midGrey : tokens.colors.midGrey}`,
  backgroundColor: 'transparent',
}));

const CustomCheckboxCheckedIcon = styled(Box)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '4px',
  border: `2px solid ${disabled ? tokens.colors.midGrey : theme.palette.primary.main}`,
  backgroundColor: disabled ? tokens.colors.midGrey : theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::after': {
    content: '"✓"',
    color: tokens.colors.offWhite,
    fontSize: '12px',
    fontWeight: 'bold',
  },
}));

const StyledCheckbox = styled(Checkbox)<CheckboxProps>(({ theme }) => ({
  padding: '8px',
  '&:hover': {
    backgroundColor: `${theme.palette.primary.main}1F`,
  },
}));

export const TrackNowCheckbox = (props: CheckboxProps) => {
  return (
    <StyledCheckbox
      {...props}
      disableRipple
      icon={<CustomCheckboxIcon disabled={props.disabled} />}
      checkedIcon={<CustomCheckboxCheckedIcon disabled={props.disabled} />}
    />
  );
};
